import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { environment } from "../../environments/environment";
import { BaseService } from "./api-base.service";
import { ReconApiService } from "./recon-api.service";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class CalendarService {
  private readonly Timeout: number = 30000;
  private readonly basePath: string = "Calendar";

  constructor(
    private http: HttpClient,
    private apiBase: BaseService,
    private reconApiService: ReconApiService
  ) {}

  public async getLastCloseDate(clientId: string): Promise<Date> {
    const url = `${environment.reconApiRoot.url}/client/${clientId}/${this.basePath}/LastCloseDate`;

    const response = await this.http
      .get<string>(url, { headers: this.apiBase.getHeaders() }) 
      .timeoutWith(
        this.Timeout,
        Observable.throw(new Error("Timeout exceeded."))
      )
      .toPromise()
      .catch((error) => {
        console.log(
          `Error occurred at ${new Date()} status: ${
            error && error.status ? error.status.toString() : "unknown"
          }`
        );
        this.reconApiService.logToElasticSearchFromUI(error, url);

      });

    if (!response) {
      return null;
    }

    // Convert JSON string → JS Date
    return new Date(response);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/calendar-api.service.ts